(function () {
  if (window.innerWidth <= 630) {
    function stickToTheTop() {
      const productAction = document.querySelector(
        "#pop-mobile-container .product-action"
      );
      const stickHere = document.querySelector("#stick-here");

      if (productAction && stickHere) {
        const windowTop = window.scrollY;
        const top = stickHere.getBoundingClientRect().top + window.scrollY - 50;

        if (windowTop > top) {
          productAction.classList.add("stick");
          stickHere.style.height = `${productAction.offsetHeight}px`;
        } else {
          productAction.classList.remove("stick");
          stickHere.style.height = "0";
        }
      }
    }

    window.addEventListener("scroll", stickToTheTop);
    stickToTheTop();
  }
})();
